import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateSeasonPoolModel } from "~pages/SeasonPools/types/seasonPoolModel.ts";
import type { PoolResponse } from "~types/pool.ts";

export const useUpdateSeasonPool = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<PoolResponse, Error, UpdateSeasonPoolModel>({
    mutationFn: async ({ poolCode, ...updateData }) =>
      await request<PoolResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/pools/${poolCode}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async (_, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["seasonPools", sport, organizationId, seasonId] }),
        queryClient.invalidateQueries({ queryKey: ["seasonPool", sport, organizationId, seasonId, variables.poolCode] }),
      ]);
    },
  });
};
